import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { StoreConfig, StoreStatusService } from 'ngx-web-api';
import { Observable } from 'rxjs';
import { filter, take } from 'rxjs/operators';

@Injectable()
export class StoreStatusResolver implements Resolve<StoreConfig> {
  constructor(private storeStatusService: StoreStatusService) {}

  resolve(): Observable<any> {
    return this.storeStatusService.storeStatus$.pipe(
      filter((status: any) => !!status?.orderType),
      take(1)
    );
  }
}
